function toggleTextVisibility(): void {
  const textContainer = document.querySelector(".p-25thanniversary-article-sticky__container");
  const toggleButton = document.querySelector(".js-toggle-button");

  if (textContainer !== null && toggleButton !== null) {
    toggleButton.addEventListener("click", () => {
      const isExpanded = textContainer.getAttribute("aria-expanded") === "true";
      const isSmallScreen = window.innerWidth <= 767;

      if (!isExpanded) {
        // 高さを取得して設定
        const fullHeight = (textContainer as HTMLElement).scrollHeight;
        (textContainer as HTMLElement).style.maxHeight = `${fullHeight}px`;
      } else {
        // 高さを初期値に戻す
        (textContainer as HTMLElement).style.maxHeight = isSmallScreen ? "440px" : "460px";
      }

      textContainer.setAttribute("aria-expanded", (!isExpanded).toString());
      toggleButton.textContent = isExpanded ? "もっと見る" : "閉じる";

      // クラスの切り替え
      toggleButton.classList.toggle("is-expanded", !isExpanded);
    });
  }
}

export { toggleTextVisibility };
